import { render, staticRenderFns } from "./DashboardQuickTips.vue?vue&type=template&id=8da3b9b6"
import script from "./DashboardQuickTips.vue?vue&type=script&lang=js"
export * from "./DashboardQuickTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports